// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ApiPingRouteImport } from './routes/api/ping'
import { Route as AuthenticatedLiveStreamRouteImport } from './routes/_authenticated/live-stream'
import { Route as AuthenticatedLiveInClubRouteImport } from './routes/_authenticated/live-in-club'
import { Route as AuthenticatedDancersRouteImport } from './routes/_authenticated/dancers'
import { Route as EmbedLiveSlugRouteImport } from './routes/embed/live/$slug'
import { Route as ApiAuthSplatRouteImport } from './routes/api/auth/$'
import { Route as AuthenticatedDancersIndexRouteImport } from './routes/_authenticated/dancers/index'
import { Route as AuthenticatedDancersNewRouteImport } from './routes/_authenticated/dancers/new'
import { Route as AuthenticatedDancersTalentIdRouteImport } from './routes/_authenticated/dancers/$talentId'

const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ApiPingRoute = ApiPingRouteImport.update({
            id: '/api/ping',path: '/api/ping',getParentRoute: () => rootRouteImport
          })
const AuthenticatedLiveStreamRoute = AuthenticatedLiveStreamRouteImport.update({
            id: '/live-stream',path: '/live-stream',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedLiveInClubRoute = AuthenticatedLiveInClubRouteImport.update({
            id: '/live-in-club',path: '/live-in-club',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDancersRoute = AuthenticatedDancersRouteImport.update({
            id: '/dancers',path: '/dancers',getParentRoute: () => AuthenticatedRoute
          })
const EmbedLiveSlugRoute = EmbedLiveSlugRouteImport.update({
            id: '/embed/live/$slug',path: '/embed/live/$slug',getParentRoute: () => rootRouteImport
          })
const ApiAuthSplatRoute = ApiAuthSplatRouteImport.update({
            id: '/api/auth/$',path: '/api/auth/$',getParentRoute: () => rootRouteImport
          })
const AuthenticatedDancersIndexRoute = AuthenticatedDancersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDancersRoute
          })
const AuthenticatedDancersNewRoute = AuthenticatedDancersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedDancersRoute
          })
const AuthenticatedDancersTalentIdRoute = AuthenticatedDancersTalentIdRouteImport.update({
            id: '/$talentId',path: '/$talentId',getParentRoute: () => AuthenticatedDancersRoute
          })





const AuthenticatedDancersRouteChildren = {
  AuthenticatedDancersTalentIdRoute: AuthenticatedDancersTalentIdRoute,AuthenticatedDancersNewRoute: AuthenticatedDancersNewRoute,AuthenticatedDancersIndexRoute: AuthenticatedDancersIndexRoute
}

const AuthenticatedDancersRouteWithChildren = AuthenticatedDancersRoute._addFileChildren(AuthenticatedDancersRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedDancersRoute: AuthenticatedDancersRouteWithChildren,AuthenticatedLiveInClubRoute: AuthenticatedLiveInClubRoute,AuthenticatedLiveStreamRoute: AuthenticatedLiveStreamRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,LoginRoute: LoginRoute,ApiPingRoute: ApiPingRoute,ApiAuthSplatRoute: ApiAuthSplatRoute,EmbedLiveSlugRoute: EmbedLiveSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)